<script setup lang="ts">
import ToastHost from '@/components/ToastHost.vue'
import UpdatePrompt from '@/components/UpdatePrompt.vue'
import AuroraBackground from '@/components/AuroraBackground.vue'
import { useAuroraReactivity } from '@/composables/useAuroraReactivity'

const { level, reactive } = useAuroraReactivity()
</script>

<template>
  <AuroraBackground
    :reactive="reactive"
    :level="level"
  />
  <router-view />
  <UpdatePrompt />
  <ToastHost />
</template>
